import { mapMutations, mapState } from 'vuex';
import { mapActions } from 'vuex';

import AppSelecionarContaBancariaDialog from '../../shared/dialogs/SelecionarContaBancariaDialog.vue';
import AppLancamentoContaDialog from './dialogs/LancamentoContaPagarDialog.vue';

import { Money } from "v-money";
import Util from '../../util/funcoes';
import { ESTADOS, STATUS_CONTA_RECEBER_PAGAR, FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR, STATUS_LANCAMENTO, TIPO_LANCAMENTO, TIPO_DOCUMENTO_CONTA } from '../../util/constantes';

export default {
  components: {
    AppSelecionarContaBancariaDialog,
    AppLancamentoContaDialog,

    Money
  },
  data() {
    return {
      infiniteLoadingId: 0,

      loadingPlanos: false,
      loadingClientes: false,
      loadingFornecedores: false,

      visibilidadeSelecionarContaBancariaDialog: false,
      visibilidadeLancamentoContaDialog: false,

      validacao: {
        cliente: [{ required: true }],
        fornecedor: [{ required: true }],
        contaPlanoConta: [{ required: true }],
        vencimento: [{ required: true, len: 10 }],
        quantidadeParcelas: [{ required: true, validator: this.validarParcelas}],
        valor: [{ required: true, type: 'number', min: 0.1 }],
      },

      tipoCredor: 'FORNECEDOR',
      tiposCredor: [
        {label: "Cliente", data: 'CLIENTE'},
        {label: "Fornecedor", data: 'FORNECEDOR'}
      ],

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      lancamentoSelecionado: { id: 0, status: "ABERTO" },

      tabSelecionada: 'detalhes',

      formaPagamento: 'VISTA',

      hoverGravar: false,
      hoverAprovar: false,
      hoverDesaprovar: false,
      hoverRemover: false,
      hoverCancelar: false,
      hoverGerarFatura: false,
      hoverFecharConta: false,
      hoverReabrirConta: false
    };
  },
  computed: {
    ...mapState('loginStore', {
      permissoes(state) {
        return state.usuarioLogado.permissoes
          .filter((permissao) => {
            return permissao.modulo === "CONTAS_PAGAR"
          })[0];
      },
    }),
    ...mapState('contasPagarStore', {
      contasPagar(state) { return state.listaContasPagar },
      contaPagarPesquisa(state) { return state.contaPagarPesquisa },
      labelQuantidade(state) { return state.labelQuantidade },
      contaPagar(state) { return state.contaPagarSelecionado },

      planosDisponiveis(state) { return state.planosDisponiveis },
      clientesDisponiveis(state) { return state.clientesDisponiveis },
      fornecedoresDisponiveis(state) { return state.fornecedoresDisponiveis },

      logs: state => state.logs,
    }),
    exibirBotaoNovoContaPagar() {
      return this.permissoes.alteracao === true;
    },
    exibirBotaoGravarContaPagar() {
      return(
        (this.contaPagar.id === 0 && this.permissoes.cadastro && this.contaPagar.status === 'PROVISORIA')
        || (this.contaPagar.id !== 0 && this.permissoes.alteracao && this.contaPagar.status === 'PROVISORIA' || this.contaPagar.status === 'ABERTA')
      )
    },
    exibirBotaoRemoverContaPagar() {
      return this.contaPagar.id != 0 && this.permissoes.remocao && (this.contaPagar.status === 'PROVISORIA' || this.contaPagar.status === 'CANCELADA');
    },
    exibirBotaoCancelarContaPagar() {
      return this.contaPagar.id != 0 && this.permissoes.cancelarConta && this.contaPagar.status === 'ABERTA';
    },
    exibirBotaoFecharConta() {
      return this.contaPagar.id != 0 && this.permissoes.fecharReabrirConta && this.contaPagar.status === 'ABERTA';
    },
    exibirBotaoReabrirConta(){
      return this.contaPagar.saldoEmAberto > 0 && this.permissoes.fecharReabrirConta && this.contaPagar.status === 'PAGA'
    },
    exibirBotaoAprovarContaPagar() {
      return this.contaPagar.id != 0 && this.permissoes.aprovarDesaprovarConta && this.contaPagar.status === 'PROVISORIA';
    },
    exibirBotaoDesaprovarContaPagar() {
      return this.contaPagar.id != 0 && this.contaPagar.contaPlanoConta.id != 0 && this.permissoes.aprovarDesaprovarConta && this.contaPagar.status === 'ABERTA';
    },
    exibirBotaoGerarRecibo() {
      return(
        (this.contaPagar.id != 0 && (this.contaPagar.status === 'ABERTA' || this.contaPagar.status === "PAGA"))
        && (this.lancamentoSelecionado.status === "EFETUADO")
        && (this.contaPagar.lancamentos.map(lancamento => lancamento.id).includes(this.lancamentoSelecionado.id))
        && this.tabSelecionada == 'lançamentos'
      );
    },
    exibirBotaoNovoLancamento() {
      return this.contaPagar.status === "ABERTA";
    },
    exibirSelectCliente() {
      return this.tipoCredor === 'CLIENTE';
    },
    exibirSelectFornecedor() {
      return this.tipoCredor === 'FORNECEDOR';
    },
    exibirLancamentos() {
      return this.contaPagar.id != 0 && (this.contaPagar.status === 'ABERTA' || this.contaPagar.status === 'PAGA');
    },
    nomeCliente(){
      return this.contaPagar.cliente ? this.contaPagar.cliente.nome : '';
    },
    nomeContaBancaria(){
      return this.contaPagar.contaBancaria ? this.contaPagar.contaBancaria.nome : ''
    },
    totalPago(){
      let totalPago = 0
      if(!this.contaPagar.lancamentos) return 0

      this.contaPagar.lancamentos.forEach(item => {
        if(item.status === 'EFETUADO'){
          totalPago += item.valor
        }
      });

      return totalPago
    },
    estados() { 
      return ESTADOS;
    },
    status() { 
      return STATUS_CONTA_RECEBER_PAGAR;
    },
    formasPagamento() { 
      return FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR;
    },
    tipoDocumento() {
      return TIPO_DOCUMENTO_CONTA;
    },
    util() { 
      return Util;
    },

    disableDataEmissao() {
      return this.contaPagar.status == 'ABERTA' || this.contaPagar.status == 'PAGA'
    },

    disableDataReconhecimento() {
      return this.permissoes.reconhecerConta == false || this.contaPagar.status == 'ABERTA';
    },

    exibirDataReconhecimento(){
      return this.contaPagar.id != 0;
    },

    isEditando() {
      return this.contaPagar.id !== 0;
    },

    isVisibleAbaLogs() {
      return this.isEditando;
    },
    isContaAprovada() {
      return this.contaPagar.status === 'ABERTA'
    },
    isContaProvisoria() {
      return this.contaPagar.status === 'PROVISORIA'
    },
    spanFormaPagamento() {
      return this.formaPagamento == 'PARCELADO' ? 6 : 12;
    },

    listaDias() {
      let dias = [];
      for(let i = 30; i >= 1; i--) {
        let objetoLista = {}
        objetoLista.label = `${i}`;
        objetoLista.value = i;

        dias.push(objetoLista);
      }
      return dias
    }
  },

  watch: {
    'contaPagar.id': function(newValue, oldValue) {
      if(oldValue !== 0) {
        this.switchTab('detalhes');
        this.limparLogs();
      }
    },
  },

  methods: {
    ...mapMutations('contasPagarStore', [
      'limparLogs',
    ]),

    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('contasPagarStore', [
      'listarContasPagar',
      'limparContasPagarListadas',
      'limparContaPagarPesquisa',
      'recuperarContaPagar',
      'novoContaPagar',
      'gravarContaPagar',
      'removerContaPagar',
      'cancelarContaPagar',
      'aprovarContaPagar',
      'desaprovarContaPagar',
      'listarPlanos',
      'listarClientes',
      'listarFornecedores',
      'atualizarLancamentoSelecionado',
      'removerLancamentoConta',
      'recuperarLancamento',
      'novoLancamento',
      'gerarRecibo',
      'recuperarLogs',
      'fecharContaPagar',
      'reabrirContaPagar'
    ]),
    ...mapActions('financeiroRelatoriosStore', [
      'gerarRelatorio'
    ]),

    validarParcelas(rule, value, callback) {
      if(value >= 2 && value <= 120) {
       return callback();
     } else {
       return callback(new Error())
     }
    },

    novo() {
      this.novoContaPagar();
      this.tabSelecionada = 'detalhes';
      this.formaPagamento = 'VISTA';
    },

    validarInputNumeroNotaFiscal($event) {
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
      if(!valoresPermitidos.includes($event.key)) {
        $event.preventDefault();
      }
    },

    selecaoLancamentoHandler(lancamento) {
      if(lancamento == null) { return; }

      this.lancamentoSelecionado = lancamento;
    },

    pesquisarHandler() {
      this.contaPagarPesquisa.pagina = 0;
      this.limparContasPagarListadas();
      this.infiniteLoadingId += 1;
    },
    pesquisar($state) {
      if(this.contaPagarPesquisa.pagina === 0) { this.showLoading(); }

      this.listarContasPagar(this.contaPagarPesquisa).then((resultado) => {
        if(this.contaPagarPesquisa.pagina === 0) { this.hideLoading(); }
        if(resultado.lista.length == 100) {
          this.contaPagarPesquisa.pagina += 1;
          $state.loaded();
        } else if(resultado.lista.length > 0 && this.contaPagarPesquisa.pagina == 0) {
          $state.loaded();
          $state.complete();
        } else {
          $state.complete();
        }
      }).catch(() => {
        if(this.contaPagarPesquisa.pagina === 0) { this.hideLoading(); }
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    limparPesquisa() {
      this.limparContaPagarPesquisa();
    },

    recuperarHandler(contaPagar) {
      this.recuperar(contaPagar);
    },
    recuperar(contaPagar) {
      this.showLoading();
      this.recuperarContaPagar(contaPagar).then((resultado) => {
        const contaRecuperada = resultado.item;
        this.alterarTipoCredor(contaRecuperada);
        if(contaRecuperada.quantidadeParcelas > 1) { this.formaPagamento = 'PARCELADO' }
        this.hideLoading();
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    gravarHandler() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          this.gravar();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      if (this.tipoCredor === 'CLIENTE') {
        this.contaPagar.fornecedor = null
       } else if (this.tipoCredor === 'FORNECEDOR') {
        this.contaPagar.cliente = null
       }
      if(this.contaPagar.dataReconhecimento && this.contaPagar.dataEmissao) {
        if(this.util.compararDatas(this.contaPagar.dataReconhecimento, this.contaPagar.dataEmissao) == -1) {
          this.exibirAlert("Atenção", "Impossível inserir uma data de reconhecimento anterior a data de emissão")
          return;
        }
      }
      if(this.formaPagamento == 'VISTA') { this.contaPagar.quantidadeParcelas = 1 }
      this.showLoading();
      this.gravarContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    removerHandler() {
      this.$confirm('Deseja realmente remover esta Conta?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.remover();
      });
    },
    remover() {
      this.showLoading();
      this.removerContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    cancelarHandler() {
      this.$confirm('Deseja realmente cancelar esta Conta?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.cancelar();
      });
    },
    cancelar() {
      this.showLoading();
      this.cancelarContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
  
    fecharHandler(){
      this.$confirm("Deseja realmente alterar o status da conta para 'Pago'?", 'Atenção!',{
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      }).then(() => {
        this.confirmarFecharContaConcluir();
      })  
    },
    confirmarFecharContaConcluir(){
      this.$confirm("Prezado cliente, ao continuar com o procedimento, a conta será marcada como Paga, ignorando o saldo em aberto. ", 
      "Atenção", {
        confirmButtonText: "Ok, estou ciente dos riscos",
        cancelButtonText: "Cancelar",
        type: "warning"
      }).then(() => {
        this.fecharContaHandler()
      }).catch(() => {});
    },

    fecharContaHandler() {
      this.showLoading();
      this.fecharContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    reabrirHandler(){
      this.$confirm("Deseja realmente Reabrir conta?", 'Atenção!',{
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        }).then(() => {
          this.reabrirContaHandler()   
        })  
    },

    reabrirContaHandler() {
      this.showLoading();
      this.reabrirContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },

    aprovarHandler() {
      this.showLoading();
      this.aprovarContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    desaprovarHandler() {
      this.showLoading();
      this.desaprovarContaPagar(this.contaPagar).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "FALHA":
            this.$message.warning(resultado.mensagem);
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    
    // LANCAMENTOS
    removerLancamentoHandler(lancamento) {
      if(lancamento.status !== "ABERTO") {
        this.$message.error("Só é possível excluir um lançamento aberto");
        return;
      }

      this.$confirm('Deseja realmente remover este Lançamento?', 'Atenção', {
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning',

      }).then(() => {
        this.removerLancamento(lancamento);
      });
    },
    removerLancamento(lancamento) {
      this.showLoading();
      this.removerLancamentoConta(lancamento).then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.pesquisarHandler();
            break;
          case "ERRO":
            this.$message.error(resultado.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    gerarReciboHandler() {
      const lancamento = { id: this.lancamentoSelecionado.id };

      let nomeRelatorio = ''
      if(this.contaPagar.fornecedor && this.contaPagar.fornecedor.personalidadeJuridica == 'PESSOA_JURIDICA') {
        nomeRelatorio = 'RECIBO_FORNECEDOR'
      } else if(this.contaPagar.fornecedor && this.contaPagar.fornecedor.personalidadeJuridica == 'PESSOA_FISICA') {
        nomeRelatorio = 'RECIBO_FORNECEDOR'
      } else {
        nomeRelatorio = 'RECIBO_FORNECEDOR_CLIENTE'
      }

      const payload = { nome: nomeRelatorio, lancamento };

      this.showLoading();
      this.gerarRecibo(payload).then((resultado) => {
        this.hideLoading();

        switch(resultado.status) {
          case "FALHA":
            this.$message.warning("Erro ao gerar o Relatório");
            break;
          case "SUCESSO":
            window.open(resultado.mensagem, "_blank");
        }
      }).catch(() => {
        this.hideLoading();

        this.$message.error("Não foi possível conectar-se ao servidor");
      });
    },
    alterarTipoCredor(conta) {
      if(conta.cliente) this.tipoCredor = 'CLIENTE';
      if(conta.fornecedor) this.tipoCredor = 'FORNECEDOR';
    },

    selecionarTab(tab) {
      if(tab.name === 'logs') {
        this.handleRecuperarLogs();
      }
    },

    handleRecuperarLogs() {
      const payload = {
        conta: {
          id: this.contaPagar.id,
        },
        pagina: -1,
      };

      this.showLoading();

      this.recuperarLogs(payload)
        .then()
        .catch(() => {
          this.$message.error("Não foi possível conectar-se ao servidor")
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    switchTab(tab) {
      this.tabSelecionada = tab;
    },

    // SELECTS
    filtrarPlanosSelect(queryString) {
      let payload = { nome: queryString, grupoPlanoConta: { tipo: 'DESPESA' } }
      this.loadingPlanos = true;
      this.listarPlanos(payload)
      .then(() => {
      this.loadingPlanos = false;  
      })
    },
    filtrarClientesSelect(queryString) {
      let payload = {};

      let reg = /^\d+$/;
      reg.test(queryString) ? payload.idNaImobiliaria = queryString : payload.nome = queryString

      this.loadingClientes = true;
      this.listarClientes(payload)
      .then(() => {
      this.loadingClientes = false;  
      })
    },
    filtrarFornecedoresSelect(queryString) {
      let payload = { nome: queryString }
      this.loadingFornecedores = true;
      this.listarFornecedores(payload)
      .then(() => {
      this.loadingFornecedores = false;  
      })
    },

    // DIALOGS
    exibirSelecionarContaBancariaDialog() { 
      this.visibilidadeSelecionarContaBancariaDialog = true 
    },
    fecharSelecionarContaBancariaDialog(contaBancaria) { 
        this.contaPagar.contaBancaria = contaBancaria
        this.visibilidadeSelecionarContaBancariaDialog = false; 
    },
    exibirLancamentoContaDialog() { 
      this.visibilidadeLancamentoContaDialog = true 
    },
    fecharLancamentoContaDialog(payload) { 
        //this.contaPagar.lancamentos.push(lancamento)
        this.visibilidadeLancamentoContaDialog = false; 
        if(payload && payload.baixouLancamento) this.pesquisarHandler();
    },

    // UTILS
    async selecionarLancamento(lancamento) {
      this.showLoading();
      
      try {
        await this.recuperarLancamento(lancamento);
        this.exibirLancamentoContaDialog();
      } catch(e) {
        this.$message.error("Não foi possível conectar-se ao servidor");
      }

      this.hideLoading();
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    coresPesquisa(status) {
      switch(status) {
        case "PROVISORIA":
          return "#4B6EF6";
        case "ABERTA":
          return "#2DB748";
        case "PAGA":
          return "#3A9AFE";
        case "CANCELADA":
          return "#DF1B1B";
      }
    },
    getLabelStatusConta(item) {
      return Util.getLabel(STATUS_CONTA_RECEBER_PAGAR, item.status);
    },
    getLabelStatusLancamento(item) {
      return Util.getLabel(STATUS_LANCAMENTO,item.status)
    },
    getLabelTipo(item) {
      return Util.getLabel(TIPO_LANCAMENTO,item.tipo)
    },
    getLabelTipoDocumentoConta(item) {
      return Util.getLabel(TIPO_DOCUMENTO_CONTA, item.tipoDocumento)
    },
    getLabelFornecedorCliente(conta) {
      if(conta.fornecedor) {
        return conta.fornecedor.nome;
      }

      if(conta.cliente) {
        return conta.cliente.nome;
      }

      return '-';
    },
    formatarSelectCliente(cliente){
      return Util.formatarSelectCliente(cliente);
    },
    formatarValor(item) {
      return Util.formatarValor(item)
    },
  }
}